module.exports = __webpack_public_path__ + "img/dry-dirt.f4e8cdbf.png";